import { FC } from 'react'
import { Button, Modal } from 'antd'
import { TRedirectDomain } from '../types'

type Props = {
 redirect?: TRedirectDomain | null
 deleting?: boolean
 onCancel: () => void
 onConfirm: () => void
}

// Delete confirmation for a redirecting domain (same look as DeleteRecordModal)
const DeleteRedirectModal: FC<Props> = ({
 redirect,
 deleting,
 onCancel,
 onConfirm,
}) => (
 <Modal
  visible={!!redirect}
  onCancel={onCancel}
  width={400}
  className="domain-delete-modal"
  footer={[
   <Button key="cancel" onClick={onCancel}>
    Cancel
   </Button>,
   <Button
    key="delete"
    type="primary"
    danger
    loading={deleting}
    onClick={onConfirm}
   >
    Delete domain
   </Button>,
  ]}
 >
  <div className="modal-icon">
   <i className="fas fa-exclamation-triangle" />
  </div>
  <h3>Delete this redirect domain?</h3>
  <p className="modal-sub">
   {redirect
    ? `"${redirect.domain}" will stop forwarding visitors and its DNS records will be removed.`
    : ''}
  </p>
 </Modal>
)

export default DeleteRedirectModal
